import { IACMessage } from './iacMessage';

export class IACEvent extends IACMessage {}
